// extracted by mini-css-extract-plugin
export var addButton = "_of-0";
export var border = "_of-8";
export var check = "_of-h";
export var danger = "_of-6";
export var dropdownContainer = "_of-1";
export var editModalBody = "_of-j";
export var footerContainer = "_of-i";
export var fullWidth = "_of-a";
export var hide = "_of-9";
export var icon = "_of-3";
export var input = "_of-7";
export var inputFlex = "_of-b";
export var inputWrapper = "_of-c";
export var manualFocus = "_of-5";
export var optionButton = "_of-4";
export var pillWrapper = "_of-e";
export var pointer = "_of-2";
export var showOverflow = "_of-f";
export var tagsFlex = "_of-d";
export var xButton = "_of-g";